var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "router-link",
        {
          staticClass: "exclusive-featured-event-link",
          attrs: { to: _vm.makeEntityRoute("event", _vm.event) }
        },
        [
          _vm.isWindowSmall || _vm.isWindowMedium
            ? _c("div", {
                staticClass:
                  "exclusive-featured-event-image exclusive-featured-event-image--mobile",
                style: {
                  backgroundImage: "url(" + _vm.event.imageUrlSquare + ")"
                }
              })
            : _c("div", {
                staticClass:
                  "exclusive-featured-event-image exclusive-featured-event-image--desktop",
                style: {
                  backgroundImage: "url(" + _vm.event.imageUrlSquare + ")"
                }
              }),
          _vm._v(" "),
          _c("div", { staticClass: "exclusive-featured-event-details" }, [
            _c(
              "div",
              { staticClass: "exclusive-featured-event-details__name" },
              [
                _c("v-clamp", { attrs: { "max-lines": 2, autoresize: "" } }, [
                  _vm._v(_vm._s(_vm.event.name))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "exclusive-featured-event-details__time" },
              [
                _vm.event.is_date_tbh
                  ? _c("span", [_vm._v(_vm._s(_vm.$t("Date TBD")))])
                  : _vm.event.is_time_tbd
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("date")(_vm.event.local_date, "ddd, MMM D")
                        ) +
                          ", " +
                          _vm._s(_vm.$t("Time TBD"))
                      )
                    ])
                  : _vm.event.local_date_label
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.event.local_date_label) + " at  "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "exclusive-featured-event-details__time-location"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("date")(_vm.event.local_date, "h:mma")
                            )
                          )
                        ]
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("date")(_vm.event.local_date, "ddd, MMM D")
                        ) + " "
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "exclusive-featured-event-details__time-location"
                        },
                        [
                          _vm._v(
                            " at " +
                              _vm._s(
                                _vm._f("date")(_vm.event.local_date, "h:mma")
                              )
                          )
                        ]
                      )
                    ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "exclusive-featured-event-details__location" },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "exclusive-featured-event-details__location-venue"
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.event.venueCity) +
                            ", " +
                            _vm._s(_vm.event.venueRegionCode)
                        ),
                        _c("span", { staticClass: "separator" }, [_vm._v("·")])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.event.is_sold_out
                      ? _c("Tag", {
                          attrs: { context: "error", text: "Sold Out" }
                        })
                      : _vm.isLoyaltyPricing && _vm.event.pointsPriceMin
                      ? _c("span", [
                          _vm._v(
                            "from " +
                              _vm._s(
                                _vm.formatPoints(
                                  _vm.event.pointsPriceMin,
                                  _vm.event.pointsCurrency
                                )
                              )
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "from " +
                              _vm._s(
                                _vm._f("numeral")(
                                  _vm.event.moneyPriceMin,
                                  "$0,0"
                                )
                              )
                          )
                        ])
                  ],
                  1
                )
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }